import React from 'react'
import Nav from '../components/Navbar'
import Hero from '../components/home/Hero'
import Footer from '../components/Footer'

const Home = () => {
  return (
    <div>
      <Nav />
        <Hero />
        <Footer />
      
    </div>
  )
}

export default Home
